/* eslint-disable import/no-anonymous-default-export */
import email from "../assets/email.png";
import mobile from "../assets/mobile.png";

import about01 from "../assets/about01.png";
import about02 from "../assets/about02.png";
import about03 from "../assets/about03.png";
import about04 from "../assets/about04.png";

// import profile from "../assets/profile.png";
import profile from "../assets/profile.gif";
import circle from "../assets/circle.svg";
import logo from "../assets/logo.png";
import logosvg from "../assets/logo.svg";

import nft from "../assets/nft.png";
import blokchain from "../assets/blokchain.png";
import web3 from "../assets/web3.0.png";

import vizyon from "../assets/vizyon.jpg";
import misyon from "../assets/misyon.jpg";
import proje from "../assets/proje.jpg";
import activity from "../assets/activity.png";

import codefictionPng from "../assets/codefiction.png";
import colinsPng from "../assets/colins.png";
import etkinkampusPng from "../assets/etkinkampus.png";
import fullseppPng from "../assets/fullsepp.png";
import kriptomedaPng from "../assets/kriptomeda.png";
import patikaDevPng from "../assets/patika.dev.png";
import uniVeChainPng from "../assets/univechain.png";

export default {
  nft,
  blokchain,
  web3,
  email,
  mobile,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  logosvg,
  vizyon,
  misyon,
  proje,
  activity,
  patikaDevPng,
  kriptomedaPng,
  fullseppPng,
  etkinkampusPng,
  colinsPng,
  codefictionPng,
  uniVeChainPng,
};
